// jQuery_T4NT(document).ready(function($) {
//  /**
//  * Variant selection changed
//  */
//   $( document ).on( "variant:change", function( evt, variant ) {
//     //console.log( variant );
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  let buttonDisable = false;
  function disableButtonFun (cart) {
    const checkoutButtonRebuy = document.querySelector(".rebuy-cart__checkout-button");
    if(cart?.length == 1 && cart?.[0]?.product_id == 6602690461756){
      buttonDisable = true;
      if(checkoutButtonRebuy){
        checkoutButtonRebuy.disabled = true;
      }
    }else{
      buttonDisable = false;
      if(checkoutButtonRebuy){
        checkoutButtonRebuy.disabled = false;
      }
    }
    replaceFreeProductLink();
  }
  
  document.addEventListener('rebuy:cart.ready', (event) => {
    let cart = event.detail?.cart?.cart?.items;
    disableButtonFun(cart);
  });

  document.addEventListener('rebuy:cart.add', (event) => { 
    let cart = event.detail?.cart?.cart?.items;
    disableButtonFun(cart);
  });

  document.addEventListener('rebuy:cart.change', (event) => { 
    let cart = event.detail?.cart?.cart?.items;
    disableButtonFun(cart);
  });

  function replaceFreeProductLink (){
    document.querySelectorAll('a[href="/products/coffee-mug-gift"]').forEach(function(anchor) {
      anchor.setAttribute('href', '#');
    });
  }

  const checkElement = function() {
      const targetElement = document.getElementById("rebuy-cart");
      if (targetElement) {
          startMutationObserver(targetElement);
      } else {
          setTimeout(checkElement, 100); // Adjust the delay as needed
      }
  };

  const startMutationObserver = function(targetElement) {
      const callback = function(mutationsList, observer) {
          for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  const isVisible = targetElement.classList.contains('is-visible');
                  replaceFreeProductLink();
                  if (isVisible) {
                      const checkoutButtonRebuy = document.querySelector(".rebuy-cart__checkout-button");
                      if(checkoutButtonRebuy){
                        checkoutButtonRebuy.disabled = buttonDisable;
                      }
                  } else {
                      replaceFreeProductLink();
                  }
              }
          }
      };
      const observer = new MutationObserver(callback);
      const config = { attributes: true, attributeFilter: ['class'] };
      observer.observe(targetElement, config);
  };
  checkElement();
});
